import { render } from "./About.vue?vue&type=template&id=6cd37c06"
const script = {}

import "./About.vue?vue&type=style&index=0&id=6cd37c06&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__